module.exports = __webpack_public_path__ + "img/lunar3.82eb1c8d.jpg";